// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2023 (original work) Open Assessment Technologies SA
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.explorer.home],
        guard: getPermissionsGuard([{ resource: 'portal.explorer', scopes: ['view'] }]),
        controller: () => import('./controllers/explorer')
    },
    {
        path: [config.routes.explorer.results],
        guard: getPermissionsGuard([{ resource: 'portal.results', scopes: ['view'] }]),
        controller: () => import('./controllers/results')
    },
    {
        path: [config.routes.explorer.view],
        guard: getPermissionsGuard([{ resource: 'portal.explorer', scopes: ['view'] }]),
        controller: () => import('./controllers/view')
    }
];
